export IntroServicesImg from '../../../public/images/services/IntroServicesImg.png';
export IntroServicesImg2x from '../../../public/images/services/IntroServicesImg@2x.png';
export Activity from '../../../public/images/services/Activity.png';
export Activity2x from '../../../public/images/services/Activity@2x.png';
export Chat from '../../../public/images/services/Chat.png';
export Chat2x from '../../../public/images/services/Chat@2x.png';
export Document from '../../../public/images/services/Document.png';
export Document2x from '../../../public/images/services/Document@2x.png';
export Filter from '../../../public/images/services/Filter.png';
export Filter2x from '../../../public/images/services/Filter@2x.png';
export Mortgage from '../../../public/images/services/Mortgage.png';
export Mortgage2x from '../../../public/images/services/Mortgage@2x.png';
export Shield from '../../../public/images/services/Shield.png';
export Shield2x from '../../../public/images/services/Shield@2x.png';
export MessageImg from '../../../public/images/services/MessageImg.png';

export redStar from '../../../public/images/home/intro/redStar.png';
export blueStar from '../../../public/images/home/intro/blueStar.png';
export greenStar from '../../../public/images/home/intro/greenStar.png';
export turquoiseStar from '../../../public/images/home/intro/turquoiseStar.png';
export redStar2x from '../../../public/images/home/intro/redStar@2x.png';
export blueStar2x from '../../../public/images/home/intro/blueStar@2x.png';
export greenStar2x from '../../../public/images/home/intro/greenStar@2x.png';
export turquoiseStar2x from '../../../public/images/home/intro/turquoiseStar@2x.png';
